import { useQuery } from "react-query"
import { getResearcherSDGReport } from "../../api/rs/researcherSDGReport"


export const useResearcherSDGReport = (crisId,onSuccess) => {
    return useQuery("get-researcher-sdg-report",() => getResearcherSDGReport(crisId), {
      onSuccess,
    });
}